import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { UserContestCollaborationWhitelistCollection } from './user-contest-collaboration-whitelist.types';

export function userContestCollaborationWhitelistBackend(): Backend<UserContestCollaborationWhitelistCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'contests/isContestCollaborationWhitelist.php',
      isGaf: true,
      params: {},
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
